module.exports = require("react-markdown");


//////////////////
// WEBPACK FOOTER
// external "react-markdown"
// module id = 161
// module chunks = 0